var _g, _path, _path2, _path3, _path4, _g2, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyMappingStateHubspot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 36,
    viewBox: "0 0 96 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyMappingStateHubspot_svg__filter0_d_1354_24060)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E1E9F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.452 8.385H18v15.23h-3.548c-1.414 0-1.927-.147-2.444-.423a2.882 2.882 0 01-1.2-1.2c-.276-.517-.423-1.03-.423-2.444v-7.095c0-1.415.147-1.928.424-2.445a2.883 2.883 0 011.199-1.2c.517-.276 1.03-.423 2.444-.423z",
    fill: "#148CFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.385h3.548c1.414 0 1.927.147 2.444.424.517.276.923.682 1.2 1.199.276.517.423 1.03.423 2.445V16H18V8.385z",
    fill: "#4DB1FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.615 16v3.548c0 1.414-.147 1.927-.423 2.444a2.884 2.884 0 01-1.2 1.2c-.517.276-1.03.423-2.444.423H18V16h7.615z",
    fill: "#F2FAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h24",
    stroke: "#E1E9F0",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyMappingStateHubspot_svg__filter1_d_1354_24060)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E1E9F0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.201 10.783v2.144a4.696 4.696 0 11-3.57 8.365l-1.741 1.742c.045.142.07.29.071.44a1.527 1.527 0 11-1.528-1.529c.15.002.298.026.44.072l1.76-1.76a4.689 4.689 0 01-.07-5.283l-5.79-4.503a1.84 1.84 0 01-.915.248 1.86 1.86 0 111.861-1.856 1.841 1.841 0 01-.066.463l5.878 4.579a4.674 4.674 0 012.223-.978v-2.144a1.65 1.65 0 01-.952-1.488v-.05c0-.91.74-1.65 1.651-1.65h.05c.911 0 1.65.74 1.65 1.65v.05a1.65 1.65 0 01-.952 1.488zm-3.13 6.782a2.41 2.41 0 002.409 2.41h.002a2.41 2.41 0 10-2.41-2.41z",
    fill: "#FF7A59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "EmptyMappingStateHubspot_svg__filter0_d_1354_24060",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1354_24060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1354_24060",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyMappingStateHubspot_svg__filter1_d_1354_24060",
    x: 60,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1354_24060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1354_24060",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMappingStateHubspot);
export default ForwardRef;